"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateQueries = void 0;
function updateQueries(_a) {
  var keys = _a.keys,
    params = _a.params,
    options = _a.options;
  var nextParams = __assign({}, params);
  var queries = [];
  for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
    var key = keys_1[_i];
    if (options[key] !== undefined) {
      if (options[key] === '') {
        delete nextParams[key];
      } else {
        nextParams[key] = options[key];
      }
    }
  }
  for (var _b = 0, keys_2 = keys; _b < keys_2.length; _b++) {
    var key = keys_2[_b];
    if (nextParams[key]) {
      queries.push(key + "=" + nextParams[key]);
    }
  }
  if (queries.length > 0) {
    return "?" + queries.join('&');
  }
  return '';
}
exports.updateQueries = updateQueries;